import { supabaseClient } from "@/lib/supabase";
import type { StateKeyT, TabKeyT } from "@/types/database/diaries";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";

import { useAuth } from "../../../../../utils/auth";
import useInvalidateDiaries from "../../../../diaries/features/edit/api/invalidateDiaries";
import { useRefetchPatientsData } from "../../overview/table/hooks/useRefetchPatientsData";
import type { Props as ActionDetailSchemaT } from "../components/ActionEmail";

type TakeActionT = {
	diary_id: string;
	action_id: string;
	tab: TabKeyT;
	state: StateKeyT;
};
export async function takeAction(
	takeActionData: ActionDetailSchemaT & { action_taker_id: string },
) {
	const { data, error } = await supabaseClient.functions.invoke(
		"public-take-action",
		{
			body: takeActionData,
		},
	);

	if (error) throw error;

	return data as TakeActionT;
}

export const useTakeAction = () => {
	const navigate = useNavigate();
	const auth = useAuth();
	const invalidateDiaries = useInvalidateDiaries();
	return useMutation({
		mutationFn: async (
			data: ActionDetailSchemaT & { action_taker_id: string },
		) => {
			return await takeAction({ ...data, action_taker_id: auth.id });
		},
		onError: (error) => {
			toast.error(`${error.message}`);
		},
		onSuccess: (data) => {
			toast.success("Action taken successfully");
			navigate({
				to: "/patients/$diaryId",
				params: { diaryId: data.diary_id },
				search: { tab: data.tab },
			});
		},
		onSettled: () => {
			invalidateDiaries();
		},
	});
};

export default useTakeAction;
